export const formatDate = (isoDate: string): string => {
  const [year, month, day] = isoDate.split("T")[0].split("-");
  return `${day}.${month}.${year}`;
};

export const formatLastEditedAt = (instant: string): string => {
  const date = new Date(instant);
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year} ${hours}:${minutes}`;
};
